export default __webpack_public_path__ + "9cc263d6b012a89bad0374b418540a31.png";